import './style.css';
import NodeComponent from "../node";
import {SettingNodeIcon} from "./icons";

export function JourneyActionNode({ id, data }) {
    return (
        <NodeComponent title="Journey" id={id} data={data} nodeTypeIcon={<SettingNodeIcon/>}>
            <div></div>
        </NodeComponent>
    );
}

